import { useCallback, useEffect, useState } from "react";
import { Activity, Loader2 } from "lucide-react";
import api from "@/lib/api";

/** What the customer has actually done with their report — report sent,
    action page opened, each CTA, and every enquiry. Read-only; it never
    touches the laboratory workflow. */
export function CustomerActionsPanel({ reference }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setBusy(true);
    try {
      const { data: d } = await api.get(
        `/admin/tank-water-health-check/bookings/${reference}/customer-actions`);
      setData(d);
    } catch { /* a missing timeline must never break the record */ }
    finally { setBusy(false); }
  }, [reference]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="mt-3 rounded-xl border border-slate-200 bg-white p-3"
      data-testid={`admin-thc-customer-actions-${reference}`}>
      <div className="flex items-center gap-2">
        <Activity className="h-4 w-4 text-cyan-700" />
        <b className="text-slate-800">Customer actions</b>
        {busy && <Loader2 className="h-3 w-3 animate-spin text-slate-400" />}
        <button onClick={load} data-testid={`admin-thc-customer-actions-refresh-${reference}`}
          className="ml-auto text-[10px] font-extrabold uppercase text-cyan-700">
          Refresh
        </button>
      </div>
      {data?.action_url && (
        <a href={data.action_url} target="_blank" rel="noreferrer"
          data-testid={`admin-thc-action-url-${reference}`}
          className="mt-2 block break-all text-[11px] font-semibold text-cyan-700">
          {data.action_url}
        </a>
      )}
      {!(data?.events || []).length ? (
        <div className="mt-2 text-[12px] text-slate-500">
          No customer activity recorded yet.
        </div>
      ) : (
        <ul className="mt-2 space-y-1">
          {data.events.map((e, i) => (
            <li key={`${e.at}-${i}`} data-testid={`admin-thc-action-event-${e.event}`}
              className="flex flex-wrap items-baseline gap-2 text-[12px]">
              <span className="font-bold text-slate-800">{e.label || e.event}</span>
              {e.cta_action && (
                <span className="rounded-full bg-cyan-50 px-2 py-0.5 text-[10px] font-bold text-cyan-800">
                  {e.cta_action}
                </span>
              )}
              <span className="text-slate-500">
                {new Date(e.at).toLocaleString("en-AU")}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
